import { useEffect } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"

import Index from "../Reports/Index.js"
import SubmittedOrders from "../Reports/SubmittedOrders.js"
import InProgressOrders from "../Reports/InProgressOrders.js"
import AgentPerformance from "../Reports/AgentPerformance.js"
import SupplierPerformance from "../Reports/SupplierPerformance.js"
import FilterOrders from "../Reports/FilterOrders.js"





export default function Reports() {

    return (
        <Routes>
            <Route path="/" element={<Index />} />
            <Route path="submittedorders" element={<SubmittedOrders />} />
            <Route path="inprogressorders" element={<InProgressOrders />} />
            <Route path="agentperformance" element={<AgentPerformance />} />
            <Route path="supplierperformance" element={<SupplierPerformance />} />
            <Route path="filterorders" element={<FilterOrders />} />
        </Routes>
    )
}


